/* global  */ // tUrl等のグローバル変数を宣言する
// import Swiper from 'swiper' // Swiper
// import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

jQuery(function($) {
  /*
       ########     ###     ######   ######## ########  #######  ########
       ##     ##   ## ##   ##    ##  ##          ##    ##     ## ##     ##
       ##     ##  ##   ##  ##        ##          ##    ##     ## ##     ##
       ########  ##     ## ##   #### ######      ##    ##     ## ########
       ##        ######### ##    ##  ##          ##    ##     ## ##
       ##        ##     ## ##    ##  ##          ##    ##     ## ##
       ##        ##     ##  ######   ########    ##     #######  ##
*/
  const scToggleFps = 5 // 1秒間の判定回数 60FPSまで上げるとほとんど負荷低減効果がなくなる
  const scToggleFrameTime = 1000 / scToggleFps
  let scToggleIsScroll = false // スクロールフラグ
  let scToggleScrollY = 0 // 縦方向のスクロール量
  let scTogglePx = 500 // スクロール半定ライン
  const scToggleTarget = document.getElementById('pagetop') // ターゲット要素
  const scToggleClass = 'active' // スイッチ用クラス
  let scToggleSwitch = false // ターゲット要素のONOFF状態

  document.addEventListener('scroll', function(ev) {
    // スクロール量の更新だけを行う
    scToggleScrollY = window.pageYOffset // スクロール量更新
    scToggleIsScroll = true // フラグON
    // console.log('Scroll:' + ++scToggleScrollCount)
  })
  scrollFadein()
  function scrollFadein() {
    // スクロールフラグが立っているときだけDOM書き換え
    if (scToggleIsScroll) {
      if (scToggleScrollY >= scTogglePx && !scToggleSwitch) {
        //トップから指定px以上スクロールしたらON
        scToggleTarget.classList.add(scToggleClass)
        scToggleSwitch = true
      } else if (scToggleScrollY < scTogglePx && scToggleSwitch) {
        //スクロールが足りない時はOFF
        scToggleTarget.classList.remove(scToggleClass)
        scToggleSwitch = false
      }
      scToggleIsScroll = false // スクロールフラグをOFFに戻す
    }
    setTimeout(scrollFadein, scToggleFrameTime) // 次回の処理を登録
  }

  /*
       #### ########          ######   ######  ########   #######  ##       ##
        ##  ##               ##    ## ##    ## ##     ## ##     ## ##       ##
        ##  ##               ##       ##       ##     ## ##     ## ##       ##
        ##  ######   #######  ######  ##       ########  ##     ## ##       ##
        ##  ##                     ## ##       ##   ##   ##     ## ##       ##
        ##  ##               ##    ## ##    ## ##    ##  ##     ## ##       ##
       #### ########          ######   ######  ##     ##  #######  ######## ########
*/
  if (navigator.userAgent.match(/MSIE 10/i) || navigator.userAgent.match(/Trident\/7\./)) {
    // マウスホイールでのスクロール時
    $('body').on('mousewheel', function() {
      // デフォルトの設定値をOFFに切り替える
      event.preventDefault()
      const wd = event.wheelDelta
      const csp = window.pageYOffset
      window.scrollTo(0, csp - wd)
    })
  }

  /*
 ########     ###    ########     ###
 ##     ##   ## ##   ##     ##   ## ##
 ##     ##  ##   ##  ##     ##  ##   ##
 ########  ##     ## ########  ##     ##
 ##        ######### ##   ##   #########
 ##        ##     ## ##    ##  ##     ##
 ##        ##     ## ##     ## ##     ##
*/
  // パララックス背景　負荷を抑えるためFPS制で処理する
  const fps = 55 // FPS設定 60まで上げるとほとんど負荷低減効果がなくなる
  const frameTime = 1000 / fps
  let isScroll = false // スクロールフラグ
  let scrollY = 0 // 縦方向のスクロール量
  // 処理頻度テスト用
  // let scrollCount = 0
  // let actionCount = 0
  document.addEventListener('scroll', function(ev) {
    // スクロール量の更新だけを行う
    scrollY = window.pageYOffset // スクロール量更新
    isScroll = true // フラグON
    // console.log('Scroll:' + ++scrollCount)
  })
  parallaxBG()
  function parallaxBG() {
    // スクロールフラグが立っているときだけDOM書き換え
    if (isScroll) {
      $('#bgPara1').css('backgroundPositionY', scrollY * -1.4)
      $('#bgPara2').css('backgroundPositionY', scrollY * -1.6)

      $('.js-para--1').css({ transform: 'translate3d(0,' + scrollY * -0.15 + 'px,0)' })
      $('.js-para--2').css({ transform: 'translate3d(0,' + scrollY * -0.3 + 'px,0)' })
      $('.js-para--3').css({ transform: 'translate3d(0,' + scrollY * -0.45 + 'px,0)' })
      $('.js-para--4').css({ transform: 'translate3d(0,' + scrollY * -0.6 + 'px,0)' })

      isScroll = false // フラグをOFFに戻す
      // console.log('Action:' + ++actionCount)
    }
    setTimeout(parallaxBG, frameTime) // 次回の処理を登録
  }

  /*
 ##    ## ######## ##      ##  ######
 ###   ## ##       ##  ##  ## ##    ##
 ####  ## ##       ##  ##  ## ##
 ## ## ## ######   ##  ##  ##  ######
 ##  #### ##       ##  ##  ##       ##
 ##   ### ##       ##  ##  ## ##    ##
 ##    ## ########  ###  ###   ######
*/
  const newsUl = $('#news')
  $.ajax({
    url: 'https://www.jvcmusic.co.jp/-/ArtistHeadline/A026674.json',
    dataType: 'jsonp',
    type: 'GET'
  })
    .done((json) => {
      for (var i = 0; i < 3; i++) {
        if (typeof json.contents.headlines[i] !== 'undefined') {
          var thisDate = json.contents.headlines[i].date.replace(/-/g, '.')
          var values = {
            url: json.contents.headlines[i].url,
            date: thisDate,
            comment: json.contents.headlines[i].comment
          }
          newsUl.append(`
          <a class="news__item md-btn plain-white left-text flex vcenter bet sp-break" href="${values.url}" target="_blank">
          <h3 class="news__title">${values.comment}</h3>
          <span class="news__date">${values.date}</span>
          </a>`)
        }
      }
    })
    .fail((json) => {
      // Ajaxリクエストが失敗
      newsUl.append(`<span class="news__item news__item--fail flex vcenter bet">
          ニュースの取得に失敗しました。時間をおいて再度お試しください。
          </span>`)
    })
    .always((json) => {
      // 成功・失敗どちらでも発動
    })

  /*
  ##       ######  #######  #####  ######
  ##      ##    ##    ###  ##   ## ##   ##
  ##      ##    ##   ###   ####### ##   ##
  ##      ##    ##  ###    ##   ## ##   ##
  #######  ######  ####### ##   ## ######
  */
  /* global lozad */
  lozad('.lozad', {
    rootMargin: '5%',
    loaded: function(el) {
      el.classList.add('active') // 画面に交差した要素をactive
    }
  }).observe()
})
